// necklace-customizer.js - Drag & Drop Charms Logic

console.log('🎯 necklace-customizer.js LOADED');

let placedCharms = [];
let availableCharms = [];
let selectedChain = null;

// Store original positions for desktop restoration
let originalChainParent = null;
let originalChainNextSibling = null;
let originalCustomizerParent = null;
let originalCustomizerNextSibling = null;
let positionsStored = false;

document.addEventListener('DOMContentLoaded', function () {
    // Hide customizer images from product gallery
    hideCustomizerImagesFromGallery();

    // Auto-initialize with current product data (direct mode)
    if (window.currentChainData) {
        autoInitializeCustomizer();
    }
    
    //handleMobilePositioning();
    
    // Handle window resize to switch between mobile and desktop layouts
    //let resizeTimer;
    //window.addEventListener('resize', function() {
    //    clearTimeout(resizeTimer);
    //    resizeTimer = setTimeout(function() {
    //        handleMobilePositioning();
    //    }, 250);
    //});
});


function hideCustomizerImagesFromGallery() {
    console.log('🖼️ Hiding customizer images from product gallery...');
    
    // Get all charm items from the customizer to count variants
    const charmItems = document.querySelectorAll('.charm-item[data-variant-id]');
    const variantCount = charmItems.length;
    
    if (variantCount === 0) {
        console.log('⚠️ No charm variants found, skipping gallery hide');
        return;
    }
    
    console.log(`� Found ${variantCount} variants in customizer`);
    
    // Get all gallery items (list items in the product media gallery)
    const galleryItems = document.querySelectorAll(
        '.product__media-list > li, ' +
        '.product__media-item, ' +
        'media-gallery li'
    );
    
    if (galleryItems.length === 0) {
        console.log('⚠️ No gallery items found');
        return;
    }
    
    console.log(`📸 Total gallery items: ${galleryItems.length}`);
    
    // Calculate how many images to hide (last N images where N = variant count)
    const totalImages = galleryItems.length;
    const imagesToHide = Math.min(variantCount, totalImages);
    const startHideIndex = totalImages - imagesToHide;
    
    console.log(`🎯 Hiding last ${imagesToHide} images (starting from index ${startHideIndex})`);
    
    // Hide the last N gallery items
    let hiddenCount = 0;
    galleryItems.forEach((item, index) => {
        if (index >= startHideIndex) {
            item.style.display = 'none';
            console.log(`✅ Hidden gallery item ${index + 1}/${totalImages}`);
            hiddenCount++;
        }
    });
    
    console.log(`✅ Successfully hidden ${hiddenCount} customizer images from gallery`);
}

function handleMobilePositioning() {
    const chainSelection = document.getElementById('chain-selection-container');
    const customizerSection = document.getElementById('necklace-customizer');
    
    // Store original positions on first run
    if (!positionsStored && chainSelection && customizerSection) {
        originalChainParent = chainSelection.parentNode;
        originalChainNextSibling = chainSelection.nextSibling;
        originalCustomizerParent = customizerSection.parentNode;
        originalCustomizerNextSibling = customizerSection.nextSibling;
        positionsStored = true;
        console.log('💾 Original positions stored');
    }
    
    // Check if we're on mobile (< 750px) or desktop (>= 750px)
    if (window.innerWidth < 750) {
        console.log('📱 Mobile detected, repositioning elements...');
        
        // Find product description element
        const descriptionElement = document.querySelector('.product__description') ||
                                   document.querySelector('[class*="description"]') ||
                                   document.querySelector('.product-details') ||
                                   document.querySelector('.rte');
        
        if (descriptionElement) {
            console.log('✅ Description element found:', descriptionElement);
            
            // Move chain selection before description if not in correct position
            if (chainSelection) {
                const isBeforeDescription = chainSelection.compareDocumentPosition(descriptionElement) & Node.DOCUMENT_POSITION_FOLLOWING;
                if (!isBeforeDescription || chainSelection.parentNode !== descriptionElement.parentNode) {
                    descriptionElement.parentNode.insertBefore(chainSelection, descriptionElement);
                    console.log('✅ Chain selection repositioned before description');
                }
            }
            
            // Move customizer before description if not in correct position
            if (customizerSection) {
                const isBeforeDescription = customizerSection.compareDocumentPosition(descriptionElement) & Node.DOCUMENT_POSITION_FOLLOWING;
                if (!isBeforeDescription || customizerSection.parentNode !== descriptionElement.parentNode) {
                    descriptionElement.parentNode.insertBefore(customizerSection, descriptionElement);
                    console.log('✅ Customizer repositioned before description');
                }
            }
            
            if (chainSelection) {
                chainSelection.style.display = 'block';
                chainSelection.classList.add('mobile-view');
            }
            
            if (customizerSection) {
                customizerSection.classList.add('mobile-view');
            }
        } else {
            console.log('⚠️ No description element found, showing in original position');
            // Fallback: show in original position
            if (chainSelection) {
                chainSelection.style.display = 'block';
                chainSelection.classList.add('mobile-view');
            }
            if (customizerSection) {
                customizerSection.classList.add('mobile-view');
            }
        }
    } else {
        // Desktop: Restore to original positions
        console.log('🖥️ Desktop detected, restoring original positions...');
        
        // Restore chain selection to original position
        if (chainSelection && originalChainParent) {
            if (chainSelection.parentNode !== originalChainParent) {
                if (originalChainNextSibling) {
                    originalChainParent.insertBefore(chainSelection, originalChainNextSibling);
                } else {
                    originalChainParent.appendChild(chainSelection);
                }
                console.log('✅ Chain selection restored to original position');
            }
            chainSelection.style.display = 'block';
            chainSelection.classList.remove('mobile-view');
        }
        
        // Restore customizer to original position
        if (customizerSection && originalCustomizerParent) {
            if (customizerSection.parentNode !== originalCustomizerParent) {
                if (originalCustomizerNextSibling) {
                    originalCustomizerParent.insertBefore(customizerSection, originalCustomizerNextSibling);
                } else {
                    originalCustomizerParent.appendChild(customizerSection);
                }
                console.log('✅ Customizer restored to original position');
            }
            customizerSection.classList.remove('mobile-view');
        }
    }
}


function autoInitializeCustomizer() {
    console.log('🚀 Auto-initializing customizer with current product...');
    
    selectedChain = {
        id: window.currentChainData.id,
        handle: window.currentChainData.handle,
        title: window.currentChainData.title,
        image: window.currentChainData.image,
        baseVariantId: window.currentChainData.baseVariantId,
        basePrice: window.currentChainData.basePrice
    };
    
    console.log('✅ Current chain loaded:', selectedChain);
    
    // Update global variables
    window.necklaceBasePrice = selectedChain.basePrice;
    window.necklaceBaseId = selectedChain.baseVariantId;
    window.necklaceBaseTitle = selectedChain.title;
    
    // Load chain image
    const necklaceImg = document.getElementById('necklace-product-image');
    const noImagePlaceholder = document.getElementById('no-product-image');
    
    if (selectedChain.image && necklaceImg) {
        necklaceImg.src = selectedChain.image;
        necklaceImg.style.display = 'block';
        if (noImagePlaceholder) noImagePlaceholder.style.display = 'none';
    }
    
    // Initialize customizer directly
    initCustomizer();
}

function initCustomizer() {
    console.log('🔄 Initialisation du personnalisateur de collier...');
    loadCharmsFromDOM();
    setupDragAndDrop();
    setupTouchDragAndDrop();
    setupEventListeners();
    setupChainVariantSelector();
    updateDesignSummary();

    // Global deselect listener
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.necklace-charm')) {
            document.querySelectorAll('.necklace-charm').forEach(c => c.classList.remove('selected'));
        }
    });

    // Touch deselect
    const base = document.getElementById('necklace-base');
    if (base) {
        base.addEventListener('touchstart', function (e) {
            if (e.target === base || e.target.classList.contains('charms-container')) {
                document.querySelectorAll('.necklace-charm').forEach(c => c.classList.remove('selected'));
            }
        });
    }
}

function setupChainVariantSelector() {
    const variantSelect = document.getElementById('chain-variant-select');
    if (!variantSelect) {
        console.log('📌 No chain variant selector found (single variant chain)');
        return;
    }

    console.log('🔗 Setting up chain variant selector...');

    variantSelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const newVariantId = parseInt(this.value);
        const newPrice = parseInt(selectedOption.dataset.price);
        const newImage = selectedOption.dataset.image;
        const newTitle = selectedOption.dataset.title;

        console.log(`🔄 Chain variant changed to: ${newTitle} (ID: ${newVariantId}, Price: ${newPrice})`);

        // Update global variables
        window.necklaceBaseId = newVariantId;
        window.necklaceBasePrice = newPrice;

        // Update selected chain object
        if (selectedChain) {
            selectedChain.baseVariantId = newVariantId;
            selectedChain.basePrice = newPrice;
        }

        // Update chain image if available
        if (newImage) {
            const necklaceImg = document.getElementById('necklace-product-image');
            const noImagePlaceholder = document.getElementById('no-product-image');
            
            if (necklaceImg) {
                necklaceImg.src = newImage;
                necklaceImg.style.display = 'block';
                if (noImagePlaceholder) noImagePlaceholder.style.display = 'none';
            }
        }

        // Update design summary to reflect new base price
        updateDesignSummary();
    });

    console.log('✅ Chain variant selector initialized');
}

function loadCharmsFromDOM() {
    const charmElements = document.querySelectorAll('.charm-item');
    availableCharms = [];

    charmElements.forEach(el => {
        const rawPrice = el.dataset.price;
        const parsedPrice = parseInt(rawPrice);
        const productHandle = el.dataset.productHandle;

        const assetImage = el.dataset.assetImage;
        const posterImage = el.dataset.posterImage;

        // Preload the Asset Image (PNG) for smooth dragging
        let preloadedImg = null;
        if (assetImage) {
            preloadedImg = new Image();
            preloadedImg.src = assetImage;
        }

        const charmData = {
            id: el.dataset.charmId,
            variant_id: parseInt(el.dataset.variantId),
            handle: productHandle,
            name: el.dataset.title,
            price: isNaN(parsedPrice) ? 0 : parsedPrice,
            // Prefer Asset Image (PNG), fallback to Poster
            image: assetImage || posterImage,
            poster_image: posterImage,
            element: el,
            dragImageObj: preloadedImg
        };
        availableCharms.push(charmData);
        console.log(`📦 Breloque: ${charmData.name} | ID Variante Panier: ${charmData.variant_id} | A un Asset? ${!!assetImage}`);
    });

    console.log(`✅ ${availableCharms.length} breloques chargées depuis le DOM`);
}


function getCharmSize() {
    return window.innerWidth < 768 ? 32 : 50;
}

function getResizedDragImage(src, size) {
    const div = document.createElement('div');
    div.style.width = `${size}px`;
    div.style.height = `${size}px`;
    div.style.position = 'absolute';
    // Place it far off-screen but technically "visible"
    div.style.top = '-9999px';
    div.style.left = '-9999px';
    div.style.zIndex = '-1';
    div.style.overflow = 'hidden';
    
    const img = document.createElement('img');
    img.src = src;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'contain';
    
    div.appendChild(img);
    document.body.appendChild(div);
    return div;
}

function setupDragAndDrop() {
    const charmItems = document.querySelectorAll('.charm-item');
    const necklaceBase = document.getElementById('necklace-base');

    charmItems.forEach(item => {
        item.addEventListener('dragstart', function (e) {
            const charmId = this.dataset.charmId;
            const charm = availableCharms.find(c => c.id === charmId);

            if (charm) {
                // Store data for drop
                e.dataTransfer.setData('text/plain', JSON.stringify(charm));
                e.dataTransfer.effectAllowed = 'copy';

                // Use the preloaded PNG image for the drag ghost
                if (charm.image) {
                    // Center the drag image
                    const size = getCharmSize();
                    const offset = size / 2;
                    
                    // Create a temporary DOM element for the ghost
                    // We prefer the DOM element approach over canvas to avoid CORS tainting issues
                    const ghostEl = getResizedDragImage(charm.image, size);
                    e.dataTransfer.setDragImage(ghostEl, offset, offset);
                    
                    // Clean up after a short delay to ensure the browser grabbed the image
                    setTimeout(() => {
                        document.body.removeChild(ghostEl);
                    }, 100);
                } else {
                    // Fallback (uses the element itself)
                     const img = this.querySelector('img');
                     if (img) {
                        e.dataTransfer.setDragImage(img, 35, 35);
                     }
                }

                this.classList.add('dragging');
            }
        });

        item.addEventListener('dragend', function () {
            this.classList.remove('dragging');
        });
    });

    if (necklaceBase) {
        necklaceBase.addEventListener('dragover', function (e) {
            e.preventDefault(); // Allow drop
            e.dataTransfer.dropEffect = 'copy';
            this.classList.add('drag-over');
        });

        necklaceBase.addEventListener('dragleave', function () {
            this.classList.remove('drag-over');
        });

        necklaceBase.addEventListener('drop', function (e) {
            e.preventDefault();
            this.classList.remove('drag-over');

            try {
                const charmData = JSON.parse(e.dataTransfer.getData('text/plain'));
                const rect = this.getBoundingClientRect();

                // Calculate relative position
                const charmSize = getCharmSize();
                const offset = charmSize / 2;
                const x = e.clientX - rect.left - offset;
                const y = e.clientY - rect.top - offset;

                placeCharmOnNecklace(charmData, x, y);
            } catch (error) {
                console.error('❌ Erreur lors de l\'analyse des données de dépôt:', error);
            }
        });
    }
}
function setupTouchDragAndDrop() {
    const charmItems = document.querySelectorAll('.charm-item');

    charmItems.forEach(item => {
        item.addEventListener('touchstart', function (e) {
            // Only handle single touch
            if (e.touches.length > 1) return;

            const touch = e.touches[0];
            const startX = touch.clientX;
            const startY = touch.clientY;
            let isDragging = false;
            let ghost = null;
            
            const charmId = this.dataset.charmId;
            const charm = availableCharms.find(c => c.id === charmId);
            if (!charm) return;

            // Do NOT preventDefault here to allow scrolling to start

            const moveHandler = (ev) => {
                const t = ev.touches[0];
                const currentX = t.clientX;
                const currentY = t.clientY;
                const deltaX = currentX - startX;
                const deltaY = currentY - startY;

                if (!isDragging) {
                    // Check if movement is horizontal (drag) or vertical (scroll)
                    // Threshold of 5px to avoid accidental locks
                    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 5) {
                        isDragging = true;
                        
                        // Initialize Ghost
                        const charmSize = getCharmSize();
                        const offset = charmSize / 2;

                        ghost = document.createElement('img');
                        ghost.src = charm.image;
                        ghost.style.position = 'fixed';
                        ghost.style.width = `${charmSize}px`;
                        ghost.style.height = `${charmSize}px`;
                        ghost.style.objectFit = 'contain';
                        ghost.style.opacity = '0.9';
                        ghost.style.zIndex = '9999';
                        ghost.style.pointerEvents = 'none';
                        ghost.classList.add('dragging-ghost');
                        
                        // Center under finger
                        ghost.style.left = (currentX - offset) + 'px';
                        ghost.style.top = (currentY - offset) + 'px';

                        document.body.appendChild(ghost);
                        this.classList.add('dragging');
                        
                        ev.preventDefault(); // Stop scrolling now that we are dragging
                    }
                } else {
                    // Continue dragging
                    ev.preventDefault();
                    if (ghost) {
                         const charmSize = getCharmSize();
                         const offset = charmSize / 2;
                         ghost.style.left = (currentX - offset) + 'px';
                         ghost.style.top = (currentY - offset) + 'px';
                    }
                }
            };

            const endHandler = (ev) => {
                if (isDragging && ghost) {
                    const t = ev.changedTouches[0];
                    this.classList.remove('dragging');
                    ghost.remove();

                    // Check drop zone
                    const necklaceBase = document.getElementById('necklace-base');
                    if (necklaceBase) {
                        const rect = necklaceBase.getBoundingClientRect();
                        const isInside = (
                            t.clientX >= rect.left &&
                            t.clientX <= rect.right &&
                            t.clientY >= rect.top &&
                            t.clientY <= rect.bottom
                        );

                        if (isInside) {
                            const charmSize = getCharmSize();
                            const offset = charmSize / 2;
                            const x = t.clientX - rect.left - offset;
                            const y = t.clientY - rect.top - offset;
                            placeCharmOnNecklace(charm, x, y);
                        }
                    }
                }

                document.removeEventListener('touchmove', moveHandler);
                document.removeEventListener('touchend', endHandler);
            };

            document.addEventListener('touchmove', moveHandler, { passive: false });
            document.addEventListener('touchend', endHandler);
        }, { passive: false });
    });
}

function placeCharmOnNecklace(charmData, x, y) {
    const charmsContainer = document.getElementById('charms-container');
    const necklaceBase = document.getElementById('necklace-base');

    if (!charmsContainer || !necklaceBase) return;

    // Unique ID for this specific placement (allowing duplicates of same charm)
    const uniqueId = `placed-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

    // Boundary checking
    const baseRect = necklaceBase.getBoundingClientRect();
    const charmSize = getCharmSize();

    // Constrain to necklace area
    const adjustedX = Math.max(0, Math.min(x, baseRect.width - charmSize));
    const adjustedY = Math.max(0, Math.min(y, baseRect.height - charmSize));

    // Create visual element
    const charmElement = document.createElement('div');
    charmElement.className = 'necklace-charm';
    charmElement.style.left = `${adjustedX}px`;
    charmElement.style.top = `${adjustedY}px`;
    charmElement.dataset.uniqueId = uniqueId;
    charmElement.dataset.variantId = charmData.variant_id;

    // Image or placeholder
    if (charmData.image) {
        const img = document.createElement('img');
        img.crossOrigin = 'anonymous';
        img.src = charmData.image;
        img.alt = charmData.name;
        charmElement.appendChild(img);
    } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'charm-text-placeholder placed';
        placeholder.textContent = charmData.name.charAt(0).toUpperCase();
        charmElement.appendChild(placeholder);
    }

    // Add delete button (optional, but good UX)
    const deleteBtn = document.createElement('span');
    deleteBtn.className = 'charm-delete-btn';
    deleteBtn.innerHTML = '×';
    deleteBtn.onclick = (e) => {
        e.stopPropagation();
        removeCharm(uniqueId);
    };
    charmElement.appendChild(deleteBtn);

    // Add rotate button
    const rotateBtn = document.createElement('span');
    rotateBtn.className = 'charm-rotate-btn';
    rotateBtn.innerHTML = '↻';
    rotateBtn.onclick = (e) => e.stopPropagation(); // Prevent click from bubbling
    charmElement.appendChild(rotateBtn);

    // Make draggable after placement
    makePlacedCharmDraggable(charmElement);

    // Make rotatable
    makeCharmRotatable(charmElement, rotateBtn, uniqueId);

    charmsContainer.appendChild(charmElement);

    // Add to state
    placedCharms.push({
        ...charmData,
        uniqueId: uniqueId,
        x: adjustedX,
        y: adjustedY,
        rotation: 0, // Initialize rotation
        element: charmElement
    });

    updateDesignSummary();
}

function makeCharmRotatable(element, handle, uniqueId) {
    let isRotating = false;
    let startAngle = 0;
    let initialRotation = 0;
    let centerX, centerY;

    const onMouseDown = (e) => {
        e.stopPropagation();
        e.preventDefault(); // Prevent scrolling/selection

        isRotating = true;

        // Get element center
        const rect = element.getBoundingClientRect();
        centerX = rect.left + rect.width / 2;
        centerY = rect.top + rect.height / 2;

        // Calculate start angle relative to center
        const clientX = e.clientX || e.touches[0].clientX;
        const clientY = e.clientY || e.touches[0].clientY;
        startAngle = Math.atan2(clientY - centerY, clientX - centerX);

        // Get current rotation
        const charm = placedCharms.find(c => c.uniqueId === uniqueId);
        initialRotation = charm ? (charm.rotation || 0) : 0;

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('touchmove', onMouseMove, { passive: false });
        document.addEventListener('touchend', onMouseUp);

        element.style.zIndex = 101; // Bring to front while rotating
    };

    const onMouseMove = (e) => {
        if (!isRotating) return;
        e.preventDefault();

        const clientX = e.clientX || e.touches[0].clientX;
        const clientY = e.clientY || e.touches[0].clientY;

        const angle = Math.atan2(clientY - centerY, clientX - centerX);
        const delta = angle - startAngle; // Angle change in radians
        const deg = delta * (180 / Math.PI);

        let newRotation = initialRotation + deg;

        // Apply rotation
        element.style.transform = `rotate(${newRotation}deg)`;

        // Update data
        const charm = placedCharms.find(c => c.uniqueId === uniqueId);
        if (charm) {
            charm.rotation = newRotation;
        }
    };

    const onMouseUp = () => {
        isRotating = false;
        element.style.zIndex = ''; // Reset z-index

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('touchmove', onMouseMove);
        document.removeEventListener('touchend', onMouseUp);
    };

    handle.addEventListener('mousedown', onMouseDown);
    handle.addEventListener('touchstart', onMouseDown, { passive: false });
}

function removeCharm(uniqueId) {
    const index = placedCharms.findIndex(c => c.uniqueId === uniqueId);
    if (index > -1) {
        const charm = placedCharms[index];
        if (charm.element) charm.element.remove();
        placedCharms.splice(index, 1);
        updateDesignSummary();
    }
}

function makePlacedCharmDraggable(element) {
    let isDragging = false;
    let startX, startY, initialX, initialY;

    const onMouseDown = (e) => {
        // Ignore if clicking delete or rotate button
        if (e.target.classList.contains('charm-delete-btn') || e.target.classList.contains('charm-rotate-btn')) return;

        // Handle selection
        document.querySelectorAll('.necklace-charm').forEach(c => c.classList.remove('selected'));
        element.classList.add('selected');

        isDragging = true;
        startX = e.clientX || e.touches[0].clientX;
        startY = e.clientY || e.touches[0].clientY;
        initialX = parseInt(element.style.left);
        initialY = parseInt(element.style.top);

        element.style.zIndex = 100;
        element.style.cursor = 'grabbing';

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('touchmove', onMouseMove, { passive: false });
        document.addEventListener('touchend', onMouseUp);

        e.preventDefault(); // Prevent scrolling on mobile
    };

    const onMouseMove = (e) => {
        if (!isDragging) return;

        const clientX = e.clientX || e.touches[0].clientX;
        const clientY = e.clientY || e.touches[0].clientY;

        const dx = clientX - startX;
        const dy = clientY - startY;

        const necklaceBase = document.getElementById('necklace-base');
        const maxX = necklaceBase.offsetWidth - element.offsetWidth;
        const maxY = necklaceBase.offsetHeight - element.offsetHeight;

        const newX = Math.max(0, Math.min(maxX, initialX + dx));
        const newY = Math.max(0, Math.min(maxY, initialY + dy));

        element.style.left = `${newX}px`;
        element.style.top = `${newY}px`;

        // Update state
        const uniqueId = element.dataset.uniqueId;
        const charm = placedCharms.find(c => c.uniqueId === uniqueId);
        if (charm) {
            charm.x = newX;
            charm.y = newY;
        }
    };

    const onMouseUp = () => {
        isDragging = false;
        element.style.zIndex = '';
        element.style.cursor = 'grab';

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('touchmove', onMouseMove);
        document.removeEventListener('touchend', onMouseUp);
    };

    element.addEventListener('mousedown', onMouseDown);
    element.addEventListener('touchstart', onMouseDown, { passive: false });
}

function updateDesignSummary() {
    const listContainer = document.getElementById('selected-charms-list');
    const totalPriceEl = document.getElementById('total-price-display');
    const btnPriceEl = document.getElementById('btn-total-price');
    const basePriceEl = document.getElementById('base-price-display');
    const addToCartBtn = document.getElementById('add-to-cart-custom');

    // 1. Update List
    if (placedCharms.length === 0) {
        listContainer.innerHTML = '<p class="empty-message">Aucune breloque sélectionnée</p>';
    } else {
        // Group by name for display? Or just list all
        // Let's list all for now, or maybe group count
        const html = placedCharms.map(charm => `
            <div class="selected-charm-item">
                <span>${charm.name}</span>
                <span>${formatMoney(charm.price)}</span>
            </div>
        `).join('');
        listContainer.innerHTML = html;
    }

    // 2. Calculate Total
    const charmsTotal = placedCharms.reduce((sum, charm) => sum + charm.price, 0);
    const basePrice = window.necklaceBasePrice || 0;
    const total = basePrice + charmsTotal;

    // 3. Update Display
    const formattedBasePrice = formatMoney(basePrice);
    const formattedTotal = formatMoney(total);
    
    if (basePriceEl) basePriceEl.textContent = formattedBasePrice;
    if (totalPriceEl) totalPriceEl.textContent = formattedTotal;
    if (btnPriceEl) btnPriceEl.textContent = formattedTotal;

    // 4. Enable/Disable Button (optional logic)
    if (addToCartBtn) {
        // addToCartBtn.disabled = placedCharms.length === 0; // Uncomment if base necklace requires charms
        addToCartBtn.disabled = false;
    }

    // Show/Hide Preview button
    const previewBtn = document.getElementById('generate-preview-btn');
    if (previewBtn) {
        previewBtn.style.display = placedCharms.length > 0 ? 'block' : 'none';
    }
}

function setupEventListeners() {
    const addToCartBtn = document.getElementById('add-to-cart-custom');
    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', addToCart);
    }

    const resetBtn = document.getElementById('reset-btn');
    if (resetBtn) {
        resetBtn.addEventListener('click', resetDesign);
    }

    const previewBtn = document.getElementById('generate-preview-btn');
    if (previewBtn) {
        previewBtn.addEventListener('click', generatePreview);
    }
}

function resetDesign() {
    placedCharms = [];
    const container = document.getElementById('charms-container');
    if (container) container.innerHTML = '';

    const previewSection = document.getElementById('preview-save-section');
    if (previewSection) previewSection.style.display = 'none';

    updateDesignSummary();
}

async function addToCart() {
    const btn = document.getElementById('add-to-cart-custom');
    const originalText = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Ajout en cours...';

    // 1. Prepare Canvas & Image
    renderCanvas(); // Ensure canvas is up to date
    const canvas = document.getElementById('necklace-preview-canvas');
    let imageBlob = null;

    if (canvas) {
        try {
            imageBlob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
        } catch (e) {
            console.error('Erreur lors de la création de l\'image d\'aperçu:', e);
        }
    }

    // 2. Prepare FormData
    const formData = new FormData();

    // Base Necklace
    formData.append('items[0][id]', window.necklaceBaseId);
    formData.append('items[0][quantity]', 1);
    formData.append('items[0][properties][_Custom_Design]', 'Yes');

    // Attach Preview Image
    if (imageBlob) {
        formData.append('items[0][properties][Design Preview]', imageBlob, 'preview.png');
    }

    // Serialize Charm Positions for Backup/Reconstruction
    const charmPositions = placedCharms.map(c => ({
        variant_id: c.variant_id,
        name: c.name,
        x: c.x,
        y: c.y,
        rotation: c.rotation || 0
    }));
    formData.append('items[0][properties][_Charm_Positions]', JSON.stringify(charmPositions));

    // Charms (aggregate quantities)
    const charmCounts = {};
    placedCharms.forEach(charm => {
        charmCounts[charm.variant_id] = (charmCounts[charm.variant_id] || 0) + 1;
    });

    let i = 1;
    for (const [variantId, qty] of Object.entries(charmCounts)) {
        formData.append(`items[${i}][id]`, variantId);
        formData.append(`items[${i}][quantity]`, qty);
        formData.append(`items[${i}][properties][_Parent_Necklace]`, window.necklaceBaseTitle);
        i++;
    }

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            // Rediriger vers le panier ou afficher le succès
            window.location.href = '/cart';
        } else {
            console.error('Erreur Panier:', data);
            alert('Erreur lors de l\'ajout au panier: ' + (data.description || data.message));
            btn.disabled = false;
            btn.innerHTML = originalText;
        }
    } catch (error) {
        console.error('Erreur Réseau:', error);
        alert('Erreur réseau lors de l\'ajout au panier.');
        btn.disabled = false;
        btn.innerHTML = originalText;
    }
}

// Helper: Simple Money Formatter
function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = window.moneyFormat || '${{amount}}';

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

// Canvas Preview Generation - Direct rendering for perfect match
function renderCanvas() {
    const container = document.getElementById('necklace-base');
    const canvas = document.getElementById('necklace-preview-canvas');
    const baseImg = document.getElementById('necklace-product-image');
    
    if (!container || !canvas || !baseImg) return;

    // Get container dimensions
    const rect = container.getBoundingClientRect();
    
    // Set canvas to match container size exactly
    canvas.width = rect.width;
    canvas.height = rect.height;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // Fill white background
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Draw the base necklace image (object-fit: contain simulation)
    const imgRatio = baseImg.naturalWidth / baseImg.naturalHeight;
    const canvasRatio = canvas.width / canvas.height;
    
    let drawWidth, drawHeight, drawX, drawY;
    
    if (canvasRatio > imgRatio) {
        // Canvas wider - constrain by height
        drawHeight = canvas.height;
        drawWidth = drawHeight * imgRatio;
        drawX = (canvas.width - drawWidth) / 2;
        drawY = 0;
    } else {
        // Canvas taller - constrain by width
        drawWidth = canvas.width;
        drawHeight = drawWidth / imgRatio;
        drawX = 0;
        drawY = (canvas.height - drawHeight) / 2;
    }
    
    ctx.drawImage(baseImg, drawX, drawY, drawWidth, drawHeight);

    // Draw all placed charms
    placedCharms.forEach(charm => {
        if (charm.element) {
            const img = charm.element.querySelector('img');
            if (img && img.complete && img.naturalWidth > 0) {
                const charmSize = getCharmSize();
                
                ctx.save();
                
                // Calculate aspect-ratio-preserving dimensions
                const imgRatio = img.naturalWidth / img.naturalHeight;
                let drawWidth, drawHeight, offsetX, offsetY;
                
                if (imgRatio >= 1) {
                    // Wider than tall - constrain by width
                    drawWidth = charmSize;
                    drawHeight = charmSize / imgRatio;
                    offsetX = 0;
                    offsetY = (charmSize - drawHeight) / 2;
                } else {
                    // Taller than wide - constrain by height
                    drawHeight = charmSize;
                    drawWidth = charmSize * imgRatio;
                    offsetX = (charmSize - drawWidth) / 2;
                    offsetY = 0;
                }
                
                // Apply rotation around charm center
                const centerX = charm.x + charmSize / 2;
                const centerY = charm.y + charmSize / 2;
                
                ctx.translate(centerX, centerY);
                ctx.rotate((charm.rotation || 0) * Math.PI / 180);
                ctx.translate(-centerX, -centerY);
                
                // Draw charm preserving aspect ratio, centered within the charm box
                ctx.drawImage(img, charm.x + offsetX, charm.y + offsetY, drawWidth, drawHeight);
                
                ctx.restore();
            }
        }
    });
}

function generatePreview() {
    renderCanvas();
    // Show section
    document.getElementById('preview-save-section').style.display = 'block';
}
